<template>
	<div class="badge layout-column layout-hv-center">
		<div class="title">
			<img class="ribbon ribbon-left" src="../../../assets/ribbon_left.png" alt="">
			<div class="text bg-black-gray1 color-white layout-row layout-hv-center">你是大推手</div>
			<img class="ribbon ribbon-right" src="../../../assets/ribbon_right.png" alt="">
		</div>
		<div class="content layout-row">
			<div class="badge-item layout-column layout-hv-center">
				<img src="" alt="">
				<div class="label color-text3">目標參與挑戰 10次</div>
				<div class="target">達標！</div>
				<div class="progress">
					<el-progress :percentage="100" color="#f9c80e" :stroke-width="18" :show-text="false"></el-progress>
				</div>
			</div>
			<font-awesome-icon icon="arrow-right" class="fa-2x" />
			<div class="badge-item layout-column layout-hv-center">
				<img src="" alt="">
				<div class="label color-text3">目標參與挑戰 50次</div>
				<div class="target layout-row color-text3">
					<div class="color-green1">20</div>/
					<div class="color-text3">50</div>
				</div>
				<div class="progress">
					<el-progress :percentage="40" color="#a5ce38" :stroke-width="18" :show-text="false"></el-progress>
				</div>
			</div>
			<font-awesome-icon icon="arrow-right" class="fa-2x" />
			<div class="badge-item layout-column layout-hv-center">
				<img src="" alt="">
				<div class="label color-text3">目標參與挑戰 100次</div>
				<div class="target layout-row color-text3">
					<div class="color-text3">20</div>/
					<div class="color-text3">100</div>
				</div>
				<div class="progress">
					<el-progress :percentage="20" color="#c0c4cc" :stroke-width="18" :show-text="false"></el-progress>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {}
};
</script>

<style lang="scss">
.badge {
	.title {
		position: relative;

		.text {
			font-size: 24px;
			width: 260px;
			height: 48px;
			z-index: 1;
			position: relative;
		}

		.ribbon {
			width: 65px;
			height: 48px;
			position: absolute;
			z-index: 0;
		}

		.ribbon-left {
			left: -35px;
			bottom: -13px;
		}

		.ribbon-right {
			right: -35px;
			bottom: -13px;
		}
	}

	.content {
		margin-top: 40px;

		.badge-item {
			margin: 0 25px;
			.label {
				font-size: 14px;
				font-weight: 500;
			}

			.target {
				font-size: 24px;
				font-weight: bold;
			}

			.progress {
				width: 150px;
			}
		}
	}
}
</style>